module.exports = __webpack_public_path__ + "images/emoji/honey_pot.fdf2e847b18dcccff5cb.png";